var _ellipse, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.24839,
    cy: 10.1657,
    rx: 5.50229,
    ry: 2.29262,
    stroke: "#959FAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7507 13.375C14.7507 14.6412 12.2872 15.6676 9.24839 15.6676C6.20955 15.6676 3.74609 14.6412 3.74609 13.375",
    stroke: "#959FAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2533 10.166C20.2533 11.4322 17.7898 12.4586 14.751 12.4586",
    stroke: "#959FAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7507 10.166V17.0439C14.7507 18.3101 12.2872 19.3365 9.24839 19.3365C6.20955 19.3365 3.74609 18.3101 3.74609 17.0439V10.166",
    stroke: "#959FAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2533 6.95605V13.8339C20.2533 15.1001 17.7898 16.1265 14.751 16.1265",
    stroke: "#959FAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70755 7.88193C9.43531 7.64823 9.26979 7.31389 9.24902 6.95571C9.24902 5.69018 11.7159 4.66309 14.7513 4.66309C17.7867 4.66309 20.2536 5.69018 20.2536 6.95571C20.2536 8.22123 17.7867 9.24833 14.7513 9.24833C14.5954 9.24833 14.4395 9.24833 14.2928 9.23916",
    stroke: "#959FAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanDashboardIcon);
export default __webpack_public_path__ + "static/media/loan-dashboard-icon.055bebc3db8ea11edd42dbc81f624652.svg";
export { ForwardRef as ReactComponent };